module.exports = __webpack_public_path__ + "img/Marisa-Tomei.3b534b2b.png";